import { contactBannerHTML } from './global'

// Funkce zkontroluje, zda je stránka custom a přidá k ní příslušnou třídu s výjmkou registrace a přidá třídu able-custom-page nebo text-page

function addPageTypeClass() {
    const customPagesClass = ['#able-custom-page', '.id--8']
    const excludeCompletely = ['.id-404']

    // Check if page should be excluded
    const shouldExclude = excludeCompletely.some((className) => $(`${className}`).length > 0)

    // Only add class if page should not be excluded
    if (!shouldExclude) {
        const customPage = customPagesClass.find((className) => $(`${className}`).length > 0)
        const pageClass = customPage ? 'able-custom-page' : 'text-page'
        $('body').addClass(pageClass)
    }
}

function add404ToBreadcrumbs() {
    const breadcrumbs = $('.breadcrumbs')

    const breadcrumb = `
        <span id="navigation-1">
            <span itemprop="name">404</span>
        </span>
    `

    breadcrumbs.append(breadcrumb)
}

function accordion(allowMultiple = false) {
    const items = document.querySelectorAll('.accordion button')

    function toggleAccordion() {
        const itemToggle = this.getAttribute('aria-expanded')

        if (!allowMultiple) {
            for (let i = 0; i < items.length; i++) {
                items[i].setAttribute('aria-expanded', 'false')
            }
        }

        this.setAttribute('aria-expanded', itemToggle === 'false' ? 'true' : 'false')
    }

    items.forEach((item) => item.addEventListener('click', toggleAccordion))
}

export function initPages() {
    addPageTypeClass()

    if ($('body').hasClass('id-404')) {
        add404ToBreadcrumbs()
    }

    if ($('body').hasClass('in-doprava-a-platba') || $('body').hasClass('in-dostawa-i-platnosc')) {
        accordion(true)
    }
}
